import { defineMessages } from 'react-intl'

export default defineMessages({
  authLoginHeadline: {
    id: 'app.email.headline',
    defaultMessage: 'Login',
  },
  authLoginPlaceholderEmail: {
    id: 'app.email.placeholder.email',
    defaultMessage: 'Your email',
  },
  authLoginPlaceholderPin: {
    id: 'app.email.placeholder.pin',
    defaultMessage: 'Enter PIN here',
  },
  authLoginValidationPinRequired: {
    id: 'app.email.validation.pinRequired',
    defaultMessage: 'PIN Code is required!',
  },
  authLoginValidationPinTooLong: {
    id: 'app.email.validation.pinTooLong',
    defaultMessage: 'PIN Code is too long!',
  },
  authLoginValidationPinNotNumeric: {
    id: 'app.email.validation.pinNotNumeric',
    defaultMessage: 'PIN Code is not numeric!',
  },
  authLoginValidationEmailNotValid: {
    id: 'app.email.validation.emailNotValid',
    defaultMessage: 'The input is not valid email',
  },
  authLoginValidationEmailRequired: {
    id: 'app.email.validation.emailNotValid',
    defaultMessage: 'The input is not valid email',
  },
  authLoginValidationTermsOfService: {
    id: 'app.email.validation.termsOfService',
    defaultMessage: 'Please accept Terms of Service!',
  },
  authLoginNotificationUnableToLogin: {
    id: 'app.email.validation.unableToLogin',
    defaultMessage: 'Unable to log you in.',
  },
  authLoginNotificationUnableToLoginToken: {
    id: 'app.email.validation.unableToLoginToken',
    defaultMessage: 'Unable to log you in with this token.',
  },
  authLoginNotificationUnableToLoginNoResponse: {
    id: 'app.email.validation.unableToLoginNoResponse',
    defaultMessage: 'Unable to log you in. Response not received.',
  },
  authLoginNotificationUnableToLoginNoToken: {
    id: 'app.email.validation.unableToLoginNoToken',
    defaultMessage: 'Unable to log you in. Token not received.',
  },
  authLoginNotificationUnableToLoginNoBilling: {
    id: 'app.email.validation.unableToLoginNoBilling',
    defaultMessage: 'Unable to log you in. Billing info not received.',
  },
  authLoginNotificationUnableToLoginNoUser: {
    id: 'app.email.validation.unableToLoginNoUser',
    defaultMessage: 'Unable to log you in. Used info not received.',
  },
  authLoginNotificationUnableToSendEmail: {
    id: 'app.email.validation.unableToSendEmail',
    defaultMessage: 'Unable to send email',
  },

  authAutoLogOutMessage: {
    id: 'app.auth.autoLogOutMessage',
    defaultMessage:
      'You will be logged out due to inactivity. Click the button below to stay logged in.',
  },
  authAutoLogOutExtendButton: {
    id: 'app.auth.autoLogOutExtendButton',
    defaultMessage: 'Extend session',
  },
  authEmailConfirmSuccess: {
    id: 'app.auth.emailConfirmSuccess',
    defaultMessage: 'Your email has been successfully confirmed. You can now log in.',
  },
  authGoToLogin: {
    id: 'app.auth.goToLogin',
    defaultMessage: 'Go to Login',
  },
})
